import { render, staticRenderFns } from "./StationDetail.vue?vue&type=template&id=23000dce&scoped=true&"
import script from "./StationDetail.vue?vue&type=script&lang=js&"
export * from "./StationDetail.vue?vue&type=script&lang=js&"
import style0 from "./StationDetail.vue?vue&type=style&index=0&id=23000dce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23000dce",
  null
  
)

export default component.exports